export default "__VITE_ASSET__CzzAcanS__"